"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoTableWrapper = exports.InfoTableHeaderTitle = exports.InfoTableHeaderSubTitle = exports.InfoTableHeaderStyled = exports.InfoTableDataStyled = exports.InfoTableColumnStyled = exports.InfoTableCellWrapper = exports.InfoTableCellStyled = exports.CellPanelWrapper = exports.CellExpandContainer = void 0;
var _polished = require("polished");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InfoTableHeaderStyled = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: 1.563rem 3.75rem;\n\tfont-size: 0.875rem;\n\tborder-bottom: 1px solid ", ";\n"])), function (props) {
  return props.theme.colors.maxBluePurple;
});
exports.InfoTableHeaderStyled = InfoTableHeaderStyled;
var InfoTableHeaderTitle = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tfont-weight: 800;\n\t", "\n\tmargin-bottom: 0.625rem;\n"])), _styledSystem.typography);
exports.InfoTableHeaderTitle = InfoTableHeaderTitle;
var InfoTableHeaderSubTitle = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t", "\n\tfont-weight: 400;\n"])), _styledSystem.typography);
exports.InfoTableHeaderSubTitle = InfoTableHeaderSubTitle;
var InfoTableDataStyled = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tpadding: 0;\n"])));
exports.InfoTableDataStyled = InfoTableDataStyled;
var InfoTableWrapper = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t", "\n\tbox-shadow: ", ";\n\tborder-radius: ", ";\n\toverflow: hidden;\n\tpadding: 0;\n"])), _styledSystem.layout, function (props) {
  return props.expandable && props.rounded ? '6px 6px 10px rgba(164, 164, 169, 0.794635)' : '';
}, function (props) {
  return props.expandable && props.rounded ? "".concat(props.theme.borderRadii.medium, "px") : '';
});
exports.InfoTableWrapper = InfoTableWrapper;
var InfoTableCellStyled = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: ", ";\n\tbackground: ", ";\n\tbackground: ", ";\n\n\tpadding: 1.438rem 1rem;\n\topacity: ", ";\n\tpointer-events: ", ";\n\t", ";\n\n\t@media (min-width: 1024px) {\n\t\tpadding: 1.438rem 3.75rem;\n\t}\n"])), function (props) {
  return props.theme.colors.cultured;
}, function (props) {
  return props.index % 2 === 0 && props.theme.colors.light;
}, function (props) {
  return props.expanded && (0, _polished.rgba)(props.theme.colors.maxBluePurple, 0.1);
}, function (props) {
  return props.disabled ? '0.5' : '';
}, function (props) {
  return props.disabled ? 'none' : '';
}, _styledSystem.flexbox);
exports.InfoTableCellStyled = InfoTableCellStyled;
var InfoTableColumnStyled = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t/* flex: ", "; */\n\t", "\n\t", "\n"])), function (props) {
  var _props$flex;
  return (_props$flex = props.flex) !== null && _props$flex !== void 0 ? _props$flex : 1;
}, _styledSystem.flexbox, _styledSystem.layout);
exports.InfoTableColumnStyled = InfoTableColumnStyled;
var CellPanelWrapper = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\tmax-height: ", ";\n\theight: ", ";\n\tvisibility: ", ";\n\topacity: ", ";\n\ttransition: all ease-in-out 500ms;\n\twidth: 100%;\n"])), function (props) {
  return props.expanded ? "".concat(props.height, "px") : '0px';
}, function (props) {
  return props.expanded ? "".concat(props.height, "px") : '0px';
}, function (props) {
  return props.expanded ? 'visible' : 'hidden';
}, function (props) {
  return props.expanded ? '1' : '0';
});
exports.CellPanelWrapper = CellPanelWrapper;
var CellExpandContainer = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\tbackground: ", ";\n\t", "\n"])), function (props) {
  return props.theme.colors.light;
}, (0, _styledSystem.variant)({
  prop: 'bg',
  scale: 'backgrounds'
}));
exports.CellExpandContainer = CellExpandContainer;
var InfoTableCellWrapper = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\tborder-radius: ", ";\n\tborder: solid 2px transparent;\n\tborder: ", ";\n\ttransition: all ease-in-out 200ms;\n\toverflow: hidden;\n"])), function (props) {
  return props.expanded && '30px';
}, function (props) {
  return props.expanded && 'solid 2px #dcdcdc';
});
exports.InfoTableCellWrapper = InfoTableCellWrapper;